module.exports = __webpack_public_path__ + "img/Etichete_de_Inventar.6b723a52.png";